<template>
  <div class="page">
    <div class="page-left">
      <img src="https://www.xaryxx.com/images/page-left.png" alt="" />
      {{ previous }}
    </div>
    <div class="page-right">
      <img src="https://www.xaryxx.com/images/page-right.png" alt="" />
      {{ next }}
    </div>
  </div>
</template>

<script>
export default {
  name: "page-item",
  props: {
    previous: {
      type: String,
      default: "上一篇：产品名称..."
    },
    next: {
      type: String,
      default: "下一篇：产品名称..."
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  margin: 0 15px;
  display: flex;
  justify-content: space-between;
  .page-left {
    display: flex;
    align-items: center;
    img {
      width: 8%;
    }
  }
  .page-right {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    img {
      width: 8%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/page-item.vue